export { ProductRecommendationsRenderer } from './ProductRecommendationsRenderer'
